import { HeadingWithList } from "../privacyPolicy/HeadingWithLIst";

const LISTELEMENTS = [
  "Any willful default or negligent act committed by You or any of Your officials or employees in relation to the performance of this Agreement.",
  "Any breach of third-party rights.",
  "Non-compliance with law in case of any notice, summons or memorandum or consumer complaint received from any Statutory Authority or in the event of institution of litigation against You for default, or any non-compliance with laws that are directly attributable to You, and You shall indemnify the Company against any awarded damages, compensation or reasonable legal fees arising out of such default or non-compliance thereof directly attributable to You.",
];

export const Indemnification = () => {
  return (
    <HeadingWithList
      heading="Indemnification"
      para={
        <p className="text-gray-500">
          You shall indemnify and hold the Company harmless from claims,
          liabilities, damages, cost (inclusive of all Legal Costs), expenses
          arising out of:
        </p>
      }
      headingStyles="font-bold text-base"
      elementWrapperStyles={"text-gray-500 ml-6 md:ml-10"}
      listElements={LISTELEMENTS}
    />
  );
};
